export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_07.1919ae0b.png";